export enum QuestionTypeShortName {
  MULTIPLE_CHOICE = 'MC',
  RANGE = 'RA',
}
